// extracted by mini-css-extract-plugin
export default {"modalDialogSize":"ZerosModalDialog_modalDialogSize__wz2LM","modalContentSize":"ZerosModalDialog_modalContentSize__ty54D","modalBodySize":"ZerosModalDialog_modalBodySize__H1a7f"};